import { render, staticRenderFns } from "./AccidentIntakeWhatHappenedForm.vue?vue&type=template&id=3b6c78e0&scoped=true"
import script from "./AccidentIntakeWhatHappenedForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeWhatHappenedForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeWhatHappenedForm.vue?vue&type=style&index=0&id=3b6c78e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c78e0",
  null
  
)

export default component.exports